// 5-step intro tutorial for first-time heroes.

import { fb } from '../core/firebase.js';
import { state } from '../core/state.js';
import { heroRef } from '../core/paths.js';

const { updateDoc } = fb;

const STEPS = [
  { icon: '🚀', title: '¡BIENVENIDO HÉROE!', desc: 'Tu vida ahora es un juego. Completa misiones para ganar XP y subir de nivel.' },
  { icon: '⚔️', title: 'MISIONES', desc: 'Cada día tendrás retos. Algunos los marcas tú, otros necesitan aprobación de un Maestro.' },
  { icon: '🪙', title: 'RECOMPENSAS', desc: 'Gana coins y canjéalos en la tienda por premios reales que tú elijas.' },
  { icon: '💓', title: 'PULSO DIARIO', desc: 'Dinos cómo te sientes cada día para ganar bonus de coins extras.' },
  { icon: '🔥', title: '¡A JUGAR!', desc: '¡Mantén tu racha activa y conviértete en una leyenda!' },
];

let step = 0;
let overlay = null;

function render() {
  const s = STEPS[step];
  overlay.innerHTML = `
    <div class="modal-box tutorial-modal">
      <div class="tutorial-icon">${s.icon}</div>
      <div class="tutorial-title">${s.title}</div>
      <div class="tutorial-desc">${s.desc}</div>
      <div class="tutorial-dots">
        ${STEPS.map((_, i) => `<span class="tutorial-dot ${i === step ? 'active' : ''}"></span>`).join('')}
      </div>
      <button class="btn btn-primary btn-block" id="tut-next">
        ${step === STEPS.length - 1 ? '¡EMPEZAR!' : 'CONTINUAR'}
      </button>
      ${step > 0 ? `<button class="btn btn-ghost btn-block" style="margin-top:8px;font-size:11px;" id="tut-skip">SALTAR</button>` : ''}
    </div>
  `;
  overlay.querySelector('#tut-next').addEventListener('click', next);
  overlay.querySelector('#tut-skip')?.addEventListener('click', finish);
}

async function next() {
  if (step < STEPS.length - 1) { step++; render(); }
  else await finish();
}

async function finish() {
  overlay?.remove();
  overlay = null;
  if (state.selectedHeroId) {
    try { await updateDoc(heroRef(state.selectedHeroId), { hasSeenIntro: true }); } catch {}
  }
}

export function startTutorial() {
  step = 0;
  if (overlay) overlay.remove();
  overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  document.body.appendChild(overlay);
  render();
}

export function checkTutorial() {
  const hero = state.heroes.find(h => h.id === state.selectedHeroId);
  if (hero && !hero.hasSeenIntro) startTutorial();
}

if (typeof window !== 'undefined') window.startTutorial = startTutorial;
